// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c02d98d6","453":"a62d1664","732":"89d9d9eb","977":"7cf6afbc"}[chunkId] + ".chunk.js";
};